import { displayEnum } from '@/filters/displayEnum';
import { documentFormMixin } from './documentForm';

export const ow003Mixin = {
  mixins: [documentFormMixin],
  computed: {
    typeOfCreator() {
      return this.dictionary.creatorTypes;
    },

    typeOfAccidents() {
      return this.dictionary.accidents;
    },

    typeOfApplicant() {
      return this.dictionary.applicants;
    },

    typeOfBenefitForms() {
      return this.dictionary.benefitForms;
    },

    typeOfScholarshipForms() {
      if (
        this.schema.data?.school?.reportType.$model !== 'Szkoła podstawowa' &&
        this.schema.data?.school?.financingType.$model !== 1 &&
        this.schema.data?.school?.schoolAddress?.terc.$model !== '066301' &&
        this.schema.data?.school?.schoolAddress?.terc.$model !== '0663011'
      ) {
        return this.dictionary.scholarshipForms;
      }
      return this.dictionary.scholarshipForms.filter(scholarshipForm => scholarshipForm.value !== 3);
    },

    typeOfBenefit() {
      return this.dictionary.benefits;
    },

    schoolTypes() {
      return this.dictionary.schoolTypes;
    },

    typeOfSchool() {
      return this.dictionary.schools;
    },

    typeOfSchoolFinancing() {
      return this.dictionary.schoolFinancingTypes;
    },

    typeOfDeviations() {
      return this.dictionary.deviations;
    },

    typesOfPayment() {
      return this.dictionary.paymentTypes;
    },

    which() {
      return this.dictionary.which;
    },

    applicantType() {
      return displayEnum(this.data.applicantType, this.typeOfApplicant);
    },

    applicantTypeDop() {
      return displayEnum(this.data.applicantType, this.typeOfApplicant, 'dop');
    },

    benefitForm() {
      return displayEnum(this.data.benefitForm, this.typeOfBenefitForms);
    },

    schoolType() {
      return displayEnum(this.data.school.schoolType, this.typeOfSchool, 'dop');
    },

    schoolTypeDop() {
      return displayEnum(this.data.school.schoolType, this.typeOfSchool, 'dop');
    },

    schoolTypeMsc() {
      return displayEnum(this.data.school.schoolType, this.typeOfSchool, 'msc');
    },

    whichMsc() {
      return displayEnum(this.data.school.schoolType, this.which, 'msc');
    },

    benefitType() {
      return displayEnum(this.data.typeOfHelp, this.typeOfBenefit);
    },

    paymentTypes() {
      return displayEnum(this.data.paymentTypes, this.typesOfPayment);
    },

    randomEventsSelected() {
      return this.data.deviations.includes(8);
    },

    randomAccidentsSelected() {
      return this.data.randomAccidents.includes(3);
    }
  }
};
